<template>

    <add
        :post-uri="route('api.v1.documents.post')"
    ></add>

</template>

<script>

import Add from "../../components/Documents/Add";

export default {

    components: {
        Add,
    },

    metaInfo: {
        title:'Add documents',
    },

    name:'DocumentsAdd',

}

</script>
